import React, { ReactNode, useState, useMemo } from "react";

interface IDecodedUserContextValue {
  data: Record<string, any> | null;
  setDecodedUser: (data: any) => void;
}

const DecodedUserContext = React.createContext<IDecodedUserContextValue>({
  data: null,
  setDecodedUser: (data: any) => {},
});

const DecodedUserProvider = ({ children }: { children: ReactNode }) => {
  const [data, setData] = useState<any>(null);

  const contextValue = useMemo(
    () => ({
      data,
      setDecodedUser: setData,
    }),
    [data]
  );

  return (
    <DecodedUserContext.Provider value={contextValue}>
      {children}
    </DecodedUserContext.Provider>
  );
};

export const useDecodedUser = () => {
  const _c = React.useContext(DecodedUserContext);

  return _c;
};

export default DecodedUserProvider;
